import { CoreHotelBooking } from '@b2c/core';
import { Divider, Flex, Input } from 'react-vant';

interface GuestInputProps {
  value?: CoreHotelBooking.Guest;
  lastNamePlaceholder: string;
  firstNamePlaceholder: string;
  lastNameInFront?: boolean;
  onChange?(guest: CoreHotelBooking.Guest): void;
  onBlur?(): void;
}

type GuestNameInputSetting = {
  onChange: ($event: string) => void;
  maxLength?: number;
  placeholder: string;
  value?: string;
  clearable?: boolean;
  onClear?: () => void;
  onBlur?: () => void;
};

export const GuestInput = (props: GuestInputProps) => {
  let firstInput: GuestNameInputSetting = {
    onChange: ($event) => firstNameChange($event),
    placeholder: props.firstNamePlaceholder,
    value: props.value?.FirstName,
    clearable: true,
    onClear: () => firstNameChange(''),
    onBlur: () => onBlur(),
  };
  let lastInput: GuestNameInputSetting = {
    onChange: ($event) => lastNameChange($event),
    placeholder: props.lastNamePlaceholder,
    value: props.value?.LastName,
    clearable: true,
    onClear: () => lastNameChange(''),
    onBlur: () => onBlur(),
  };
  if (props.lastNameInFront) {
    [firstInput, lastInput] = [lastInput, firstInput]; // swap
  }

  function firstNameChange(value: string) {
    props.onChange({
      ...props.value,
      FirstName: value?.trim(),
    });
  }
  function lastNameChange(value: string) {
    props.onChange({
      ...props.value,
      LastName: value?.trim(),
    });
  }
  function onBlur() {
    props.onBlur?.call(null);
  }
  return (
    <Flex gutter={10}>
      <Flex.Item flex="1">
        <Input
          onChange={($event) => firstInput.onChange($event)}
          maxLength={firstInput.maxLength ?? 50}
          clearable={firstInput.clearable}
          placeholder={firstInput.placeholder}
          value={firstInput.value}
          onClear={() => firstInput.onClear?.call(null)}
          onBlur={() => firstInput.onBlur?.call(null)}
        />
      </Flex.Item>
      <Flex.Item>
        <Divider type="vertical"></Divider>
      </Flex.Item>
      <Flex.Item flex="1">
        <Input
          onChange={($event) => lastInput.onChange($event)}
          maxLength={lastInput.maxLength ?? 50}
          clearable={lastInput.clearable}
          placeholder={lastInput.placeholder}
          value={lastInput.value}
          onClear={() => lastInput.onClear?.call(null)}
          onBlur={() => lastInput.onBlur?.call(null)}
        />
      </Flex.Item>
    </Flex>
  );
};
